import { render, staticRenderFns } from "./shipmentRequestUpdate.vue?vue&type=template&id=7cf4b568&scoped=true"
import script from "./shipmentRequestUpdate.vue?vue&type=script&lang=js"
export * from "./shipmentRequestUpdate.vue?vue&type=script&lang=js"
import style0 from "./shipmentRequestUpdate.vue?vue&type=style&index=0&id=7cf4b568&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf4b568",
  null
  
)

export default component.exports